type SearchParamValue = [string, string]

const parseSearch = (search: string): SearchParamValue[] => {
    if(search == '') {
        return []
    }    
    var query = search.substring(1)
    var vars = query.split('&')
    let result: SearchParamValue[] = []
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        result.push([decodeURIComponent(pair[0]), decodeURIComponent(pair[1])])        
    }
    return result
}

const buildSearch = (values: SearchParamValue[]): string => {
    if(values.length == 0) {
        return ''
    }
    const fragments = values.map(pair => encodeURIComponent(pair[0])+'='+encodeURIComponent(pair[1]))
    return '?' + fragments.join('&')
}

export const getSearchUrl = (search: string) => window.location.protocol + '//' + window.location.host + window.location.pathname + search

export const getSearch = (): SearchParamValue[] => {
    return parseSearch(window.location.search)
}

export const setSearch = (search: SearchParamValue[]) => {
    const packed = buildSearch(search)
    var url = getSearchUrl(packed)
    window.history.pushState({path:url},'', url)
}

export const updateSearchItem = (old: SearchParamValue[], key: string, value: string | undefined): SearchParamValue[] => {
    if(value === undefined) {
        return old.filter(([itemKey, itemValue]) => itemKey != key)        
    }

    let result: SearchParamValue[] = []
    let found = false
    for(const [itemKey, itemValue] of old) {
        if(itemKey == key) {
            result.push([itemKey, value])
            found = true
        } else {
            result.push([itemKey, itemValue])
        }
    }
    if(!found) {
        result.push([key, value])
    }
    return result
}

export const getSearchItem = (search: SearchParamValue[], key: string): string|undefined => {
    const result = search.find(([itemKey, itemValue]) => itemKey==key)
    if(result === undefined) {
        return undefined
    }
    return result[1]
}